import React from "react";
import { useNavigate } from "react-router-dom";
import Logo from "../assets/Images/Logo-white.png";

const Categories = () => {
  const navigate = useNavigate();

  const categories = [
    {
      id: "leaderboard",
      name: "Leaderboard",
      description: "Hall of Champions — team rankings",
      icon: "🏆",
      color: "from-indigo-500 to-indigo-600",
      bgColor: "bg-indigo-50",
      borderColor: "border-indigo-200",
      isLeaderboard: true,
    },
    {
      id: "doubles",
      name: "Doubles",
      description: "2 tournament points per match win",
      icon: "👬",
      color: "from-green-500 to-green-600",
      bgColor: "bg-green-50",
      borderColor: "border-green-200",
    },
  ];

  const handleCategoryClick = (category) => {
    if (category.isLeaderboard) {
      navigate("/leaderboard");
      return;
    }
    navigate(`/category/${category.name}`);
  };

  return (
    <div className="min-h-screen">
      {/* Header */}
      <div
        style={{
          background:
            "linear-gradient(99.32deg, rgb(1, 30, 72) -0.41%, rgb(17, 64, 132) 93.61%)",
        }}
        className="text-white p-6 pb-8"
      >
        <h1 className="text-2xl font-bold text-center mb-3 mt-8">Live Score</h1>
        <p className="text-center text-sm opacity-90 mb-3 mt-4">Powered by</p>
        <div className="flex justify-center mb-8">
          <img src={Logo} alt="PLLAYER" className="h-8" />
        </div>
      </div>

      {/* Main Content */}
      <div className="max-w-md mx-auto">
        <div className="space-y-4 p-4">
          {categories.map((category) => (
            <div
              key={category.id}
              onClick={() => handleCategoryClick(category)}
              className={`${category.bgColor} ${category.borderColor} border-2 rounded-lg p-6 cursor-pointer transition-all hover:shadow-lg hover:scale-105`}
            >
              <div className="flex items-center space-x-4">
                <div
                  className={`w-16 h-16 rounded-full bg-gradient-to-r ${category.color} flex items-center justify-center text-white text-2xl`}
                >
                  {category.icon}
                </div>
                <div className="flex-1">
                  <h3 className="text-lg font-semibold text-gray-800 mb-1">
                    {category.name}
                  </h3>
                  <p className="text-sm text-gray-600">
                    {category.description}
                  </p>
                </div>
                <div className="text-gray-400">
                  <svg
                    className="w-6 h-6"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M9 5l7 7-7 7"
                    />
                  </svg>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Categories;
